export default __webpack_public_path__ + "static/media/barChart.dac7aaab.svg";